import { updateField } from 'vuex-map-fields';

const initialState = {
  loadingConnectedDatasets: false,
  connectedDatasets: [],
  errorConnectedDatasets: null
};

const cache = new Map();

const actions = {
  async fetchConnectedDatasets({ commit }, { platformClient, account, database, schema, name }) {
    commit('setLoadingConnectedDatasets', true);
    commit('setErrorConnectedDatasets', null);
    const tableId = `${account.toUpperCase()}.${database.toUpperCase()}.${schema.toUpperCase()}.${name.toUpperCase()}`;
    if (cache.has(tableId)) {
      commit('setConnectedDatasets', cache.get(tableId));
      commit('setLoadingConnectedDatasets', false);
      return;
    }
    try {
      const response = await platformClient.get(`https://metadata-propagation.data-discovery.cimpress.io/v0/accounts/${account}/databases/${database}/schemas/${schema}/objects/${name}/connectedDatasets`);
      const result = response.data;
      const items = result._embedded.item || [];
      cache.set(tableId, items);
      commit('setConnectedDatasets', items);
    } catch (err) {
      commit('setErrorConnectedDatasets', err.message || 'Unknown error fetching connected datasets');
    }
    commit('setLoadingConnectedDatasets', false);
  }
};

const mutations = {
  updateField,
  setLoadingConnectedDatasets(state, loading) {
    state.loadingConnectedDatasets = loading;
  },
  setConnectedDatasets(state, datasets) {
    state.connectedDatasets = datasets;
  },
  setErrorConnectedDatasets(state, error) {
    state.errorConnectedDatasets = error;
  }
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations
};
